export default {
    namespaced: true,

    state: {
        active: false,
        modalActive: false,
    },

    getters: {
        active(state) {
            return state.active;
        },
    },

    mutations: {
        toggleModal(state, value) {
            state.modalActive = value;
        },

        toggle(state, value) {
            state.active = value;
        },
    },
};
